module.exports = __webpack_public_path__ + "img/40_66.c064dc3b.png";